import Vue from 'vue'
import VueRouter from 'vue-router'
import MainLayout from '../views/layout/mainLayout.vue'
import Home from '../views/HomeView.vue'
import Products from '../views/ProductList.vue'
import ProductDetail from '../views/ProductDetail.vue'
import Basket from '../views/Basket.vue'
import Checkout from '../views/Checkout.vue'
import Login from '../views/Login.vue'
import Profile from '../views/ProfileView.vue'
import Register from '../views/Register.vue'
import Contact from '../views/ContactView.vue'
import Dashboard from '../views/LoginUser/DashboardView.vue'
import PaymentAuth from '../views/PaymentAuthView.vue'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: MainLayout,
    redirect: '/home',
    children: [{
      path: '/',
      name: 'Home',
      component: Home
    }, {
      path: '/products',
      name: 'Products',
      component: Products
    }, {
      path: '/productDetail',
      name: 'productDetail',
      component: ProductDetail
    }, {
      path: '/basket',
      name: 'Basket',
      component: Basket
    }, {
      path: '/checkout',
      name: 'Checkout',
      component: Checkout
    }, {
      path: '/login',
      name: 'Login',
      component: Login
    }, {
      path: '/register',
      name: 'Register',
      component: Register
    }, {
      path: '/contact',
      name: 'Contact',
      component: Contact
    }, {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard
    }, {
      path: '/payment_auth',
      name: 'PaymentAuth',
      component: PaymentAuth
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: {
        requiresAuth: true
      }
    }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !store.state.idToken) {
    next({ name: 'Login' })
  } else if (!to.meta.requiresAuth) {
    next()
  } else {
    if (store.state.user) {
      if (store.state.user.name !== null) {
        next()
      } else {
        next({ name: 'AuthError' })
      }
    } else {
      next()
    }
  }
})

export default router
